<p-dialog
  [visible]="visible()"
  (onHide)="close()"
  [modal]="true"
  [closable]="false"
  [dismissableMask]="dismissableMask()"
  [draggable]="false"
  [resizable]="false"
  [style]="{width: width()}"
  [styleClass]="dialogStyleClass()"
  [contentStyle]="contentPadding() ? {padding: '2rem'} : undefined"
  [attr.data-testid]="testId()"
>
  <ng-template #header>
    <div class="flex justify-between items-center w-full" [attr.data-testid]="testId() + '-header'">
      <h1 [class]="'m-0 ' + titleClass()" [attr.data-testid]="testId() + '-title'">
        {{ title() | transloco }}
      </h1>
      <p-button
        icon="pi pi-times"
        (onClick)="close()"
        variant="text"
        severity="secondary"
        [attr.data-testid]="testId() + '-close-button'"
      ></p-button>
    </div>
  </ng-template>

  <ng-content />

  <div class="flex justify-end gap-3 mt-8">
    <p-button
      [label]="cancelLabel() | transloco"
      severity="secondary"
      [outlined]="true"
      (onClick)="close()"
      [attr.data-testid]="testId() + '-cancel-button'"
    ></p-button>
    @if (submitLabel()) {
      <p-button
        [label]="submitLabel() | transloco"
        [disabled]="submitDisabled()"
        (onClick)="submit()"
        [attr.data-testid]="testId() + '-submit-button'"
      ></p-button>
    }
  </div>
</p-dialog>
